import { Alert, AlertDescription, AlertTitle } from "@typedoc/ui";
import type { AppError } from "../lib/app-error";

/**
 * The single place an AppError becomes visible product copy. Messages already come from the
 * shared catalog, so this only decides presentation: never render a raw exception here.
 */
export function ErrorNotice({
  error,
  variant = "warning",
  className,
  title,
}: {
  error: AppError | null | undefined;
  variant?: "warning" | "destructive";
  className?: string;
  // Explicitly optional-or-undefined, like `error` above: callers decide whether a failure gets
  // a title from state, and `exactOptionalPropertyTypes` will not let them pass the absence.
  title?: string | undefined;
}) {
  if (!error) return null;
  return (
    <Alert variant={variant} className={className}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        aria-hidden="true"
      >
        <circle cx="10" cy="10" r="7.25" />
        <path d="M10 6.5v4" strokeLinecap="round" />
        <circle cx="10" cy="13.5" r=".75" fill="currentColor" stroke="none" />
      </svg>
      {title && <AlertTitle>{title}</AlertTitle>}
      <AlertDescription className="text-body-foreground">
        <p>{error.message}</p>
        {error.requestId && (
          <p className="auth-note support-reference">Support reference: {error.requestId}</p>
        )}
      </AlertDescription>
    </Alert>
  );
}
